import { useAppSelector } from '@/redux/hooks';
import { getCatalogIsLAPayments } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getCatalogItemIdsByCatalogId } from '@/redux/modules/catalog/items/catalogItems.selectors';
import { getAnyItemHasLiveShipping } from '@/redux/modules/item/summary/itemSummary.selectors';

import { useShouldShowPurchaseProtectionBanner } from './useShouldShowPurchaseProtectionBanner';

export const useCatalogPurchaseProtectionEligible = (catalogId: number): boolean => {
    const shouldShowForUser = useShouldShowPurchaseProtectionBanner();
    const livePaymentsEnabled = useAppSelector((state) => getCatalogIsLAPayments(state, catalogId));
    const itemIds = useAppSelector((state) => getCatalogItemIdsByCatalogId(state, catalogId));
    const catalogHasLiveShipping = useAppSelector((state) => getAnyItemHasLiveShipping(state, itemIds));

    return shouldShowForUser && livePaymentsEnabled && catalogHasLiveShipping;
};
